module.exports = __webpack_public_path__ + "img/NewsSection.586c903c.png";